import { useEffect } from 'react';
import { useSetStore } from '../../stores/create-order/order-store';
import Body from './body';
import Footer from './footer';
import Header from './header';
import SideNav from './side-nav';
import { useCustomerPortalGlobalStore } from '../../stores/customer-portal-global-store';
import '../../common/themes/styles/dx.generic.dark-theme.css';
import '../../common/themes/styles/dx.generic.blue-theme.css';
import '../../common/themes/styles/dx.generic.green-theme.css';

const dxSwatchClassByTheme: Record<string, string> = {
  dark: 'dx-swatch-dark-theme',
  light: ''
};

const Layout = () => {
  const setAccount = useSetStore();
  const [selectedTheme] = useCustomerPortalGlobalStore(
    store => store.store.selectedTheme
  );
  const activeTheme = selectedTheme === 'dark' ? 'dark' : 'light';

  useEffect(() => {
    setAccount({
      account: {
        id: '42c0e604-9b3e-44d9-b029-77e0a77180e9',
        name: 'Ford'
      }
    });
  }, [setAccount]);

  return (
    <>
      <div
        className={`main-layout d-flex flex-row ${dxSwatchClassByTheme[activeTheme]}`}
      >
        <div className="side-nav">
          <SideNav />
        </div>
        <div className="main-layout-body-div w-100">
          <Header />
          <Body />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
